import { AbstractFacade } from '@goparrot/axios';
import { plainToInstanceWithLVS } from '@goparrot/common';
import deepmerge from 'deepmerge';
import { stringify } from 'query-string';
import { ListPromotionDto } from '../dto';
import { PromotionExposeGroup } from '../interface';
export class MerchantPromotionV3Facade extends AbstractFacade {
    constructor(config = {}, interceptors = {}) {
        super(deepmerge.all([
            {
                axiosConfig: {
                    baseURL: process.env.GOPARROT_PLATFORM_SERVICE_PROMOTION,
                },
            },
            config,
        ]), interceptors);
    }
    async list(merchantId, filter, pagination) {
        const { data: promotionList } = await this.client.get(`/api/v3/merchants/${merchantId}/promotions`, {
            params: { ...filter, ...pagination },
            paramsSerializer: (params) => stringify(params, { arrayFormat: 'separator', arrayFormatSeparator: '|' }),
        });
        return plainToInstanceWithLVS(ListPromotionDto, promotionList, { groups: [PromotionExposeGroup.READ] });
    }
}
//# sourceMappingURL=MerchantPromotionV3Facade.js.map